<template>
  <a @click="routerPage(ebook)" class="content-card-ebook">
    <div class="content-card-ebook--image"  :style="{ background: `url(data:image/jpg;base64,${ebook.picture})` }"></div>
    <div class="content-card-ebook--text">
      <h2>{{ ebook.name }}</h2>
      <h3>{{ ebook.author }}</h3>
    </div>
  </a>
</template>

<script>
export default {
  props: ['ebook'],
  methods: {
    routerPage(ebook) {
      this.$router.push({
        name: 'RegisterEbooks',
        params: {
          id: ebook.id
        },
      });
    },
  }
}
</script>

<style lang="scss">
.content-card-ebook {
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  border-radius: 20px;
  margin-bottom: 30px;
  transition: 500ms;
  &:hover,&:focus {
    cursor: pointer;
    opacity: 0.8;
  }
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 20px 20px 0px 0px;
  }
  &--text {
    padding: 10px 15px 20px 15px;
    text-align: left;
    h2 {
      font-size: 16px;
      font-family: 'Font Semibold';
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px){
        height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    h3 {
      font-size: 14px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px){
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
